<template>
  <v-dialog v-model="dialog" persistent width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        small
        outlined
        :disabled="selected.length === 0 || loading"
        color="primary"
        class="mx-2"
        v-on="on"
        @click="dialog = true"
        >{{ title }}</v-btn
      >
    </template>

    <v-card>
      <v-card-title>{{ title }} </v-card-title>
      <v-card-text class="body-1 font-weight-medium">
        {{ message }}
      </v-card-text>
      <v-card-text v-if="otherInvoicesInGroup.length > 0" class="font-italic">
        *** includes invoices linked to selected group sessions:
        <div v-for="g in otherInvoicesInGroup" :key="g.sessionInvoiceId">
          {{ g.clientName }} {{ g.formattedDos }} ({{ g.providerName }})
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          dark
          :disabled="loading"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          :dark="!loading"
          :disabled="loading"
          @click="save"
          >OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["removeOnly", "selected"],
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    invoiceBatchId() {
      return this.$store.state.billingModule.selectedInvoiceBatch
        .invoiceBatchId;
    },
    title() {
      return this.removeOnly
        ? "Remove From Batch"
        : "Remove, Unlock and Freeze";
    },
    message() {
      return this.removeOnly
        ? `This will remove ${this.invoicesToRemove.length} session invoice(s) from the batch.`
        : `This will remove ${this.invoicesToRemove.length} session invoice(s) from the batch and notify provider(s) that session is open for changes and payment will be withheld until billing successfully posts.`;
    },
    otherInvoicesInGroup() {
      return this.selected
        .map((x) =>
          this.$store.getters["billingModule/getOtherSessionInvoicesInGroup"](
            x.sessionInvoiceId, x.errorMessage
          )
        )
        .flat();
    },
    invoicesToRemove() {
      var grp = this.selected.concat(this.otherInvoicesInGroup);
      // get distinct list
      return Array.from([
        ...new Map(grp.map((item) => [item.sessionInvoiceId, item])).values(),
      ]);
    },
  },
  methods: {
    async save() {
      this.loading = true;
      this.$store.commit("uxModule/setShowLoader", true);

      let removedInvoiceIds, message;
      if (this.removeOnly) {
        ({ removedInvoiceIds, message } = await this.$store.dispatch(
          "billingModule/removeSessionInvoices",
          {
            invoiceBatchId: this.invoiceBatchId,
            sessionInvoiceIds: this.invoicesToRemove.map(
              (x) => x.sessionInvoiceId
            ),
          }
        ));
      } else {
        ({ removedInvoiceIds, message } = await this.$store.dispatch(
          "billingModule/removeAndFreeze",
          {
            invoiceBatchId: this.invoiceBatchId,
            sessionInvoices: this.invoicesToRemove,
          }
        ));
      }
      this.loading = false;
      this.$store.commit("uxModule/setShowLoader", false);

      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
        this.$store.commit("uxModule/setShowSnackbar", true);
      }

      if (removedInvoiceIds.length > 0)
        this.$emit("syncInvoices", removedInvoiceIds);

      this.dialog = false;
    },
  },
};
</script>
